export const formatNumPrice = (value) => {
  const formattedString = Math.ceil(value)
    .toString()
    .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  return formattedString
}
